import { render } from "./CouponListPage.vue?vue&type=template&id=700ae1de&scoped=true"
import script from "./CouponListPage.vue?vue&type=script&lang=js"
export * from "./CouponListPage.vue?vue&type=script&lang=js"

import "./CouponListPage.vue?vue&type=style&index=0&id=700ae1de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-700ae1de"

export default script